export const resolveBoolean = (value: any): boolean => {
  if (typeof value === 'string')
    return value.toLowerCase() === 'true'

  if (typeof value === 'boolean')
    return value

  return !!value
}
